// Single source of truth for the backend base URL — every API call/link should import from here.
//
// Local dev: leave REACT_APP_API_URL unset. Axios calls stay relative ('/api') and go through
// CRA's "proxy" (package.json -> http://localhost:8090), which avoids CORS issues.
// Direct browser links (file downloads, target="_blank") can't use the proxy, so they fall back
// to API_ORIGIN (http://localhost:8090) explicitly.
//
// Production: set REACT_APP_API_URL in .env.production (already set to the live backend).
// Both axios calls and direct links then point straight at that URL.
const ENV_API_URL = process.env.REACT_APP_API_URL || '';

export const API_ORIGIN = ENV_API_URL || 'http://localhost:8090';
export const API_BASE_URL = `${ENV_API_URL}/api`;
